export enum TableLabelCellEnum {
  GREY = 'grey',
  RED = 'red',
  RED_MARKETING = 'red-marketing',
  BLUE = 'blue',
  GREEN = 'green',
  YELLOW = 'yellow',
}
